























































































import Vue from 'vue'
import _ from 'lodash'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxFilterRow, DxGrouping, DxGroupPanel,
  DxScrolling,
  DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import { FETCH_TICKETING_ART } from '@/store/action-types'
import TicketingWindow from '@/components/ticketing/TicketingWindow.vue'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { loadMessages, locale } from 'devextreme/localization'
import { KeyAction } from '@/model/KeyAction'
import { KeyActionEnum } from '@/types/enums'
import { keyActionService } from '@/services/key-action-service'

class SelectAll extends KeyAction {}

interface ComponentData {
  tableHeight: string,
  loading: boolean
  showDialog: boolean
  ticketingIdList: number[]

  ticketingArtList: any[]

  nummer: any
  status: any
  priority: any
  ANSortierung: any
  adressNummer: any
  adressSBName: any
  ticketingArt: any
  bezeichnung: any
  beschreibung: any
  verantwortlich: any
  externeReferenz: any
  externeReferenz2: any
  produkt: any
  verknupftMit: any
  externeReferenz3: any
  GSAnzeigen: any
  maxRecords: number

  ticketingList: any[],
  isDetailButtonDisabled: boolean,

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'TicketingSearchPage',

  components: {
    TicketingWindow,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring
  },

  props: {
    ticketingGroupId: Number
  },

  data (): ComponentData {
    return {
      tableHeight: '',
      loading: false,
      showDialog: false,
      ticketingIdList: [],

      ticketingArtList: [],

      nummer: null,
      status: null,
      priority: null,
      ANSortierung: null,
      adressNummer: null,
      adressSBName: null,
      ticketingArt: null,
      bezeichnung: null,
      beschreibung: null,
      verantwortlich: null,
      externeReferenz: null,
      externeReferenz2: null,
      produkt: null,
      verknupftMit: null,
      externeReferenz3: null,
      GSAnzeigen: null,
      maxRecords: 500,

      ticketingList: [],
      isDetailButtonDisabled: true,

      keyActions: []
    }
  },

  watch: {
    $route (newVal: any): void {
      if(newVal.query.create) {
        this.ticketingIdList = [0]
        this.showDialog = true
      }

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    },

    ticketingGroupId (newVal: number): void {
      if(newVal) {
        this.ticketingArt = newVal
      }
    }
  },

  computed: {
    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: SelectAll | null): boolean {
      if(action instanceof SelectAll) {
        return !this.showDialog
      } else {
        return false
      }
    },

    selectAll (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }
      //@ts-ignore
      this.$refs.dataGrid.instance.selectAll()
    },

    startCreate (): void {
      this.ticketingIdList = [0]
    },

    ticketCreated (id: number): void {
      this.ticketingIdList = [id]
    },

    ticketEdited (): void {
      this.searchTickets()
    },

    ticketDeleted (id: number) : void {
      this.ticketingIdList.splice(this.ticketingIdList.indexOf(id), 1)
      if(this.ticketingIdList.length === 0) {
        this.showDialog = false
        this.searchTickets()
      } else {
        this.searchTickets()
      }
    },

    onCloseDialog (): void {
      this.showDialog = false
      this.ticketingIdList = []
      let data: any = this.getRouteData()
      if(data.showDialog !== undefined) {
        delete data.showDialog
      }
      if(data.addressTab != undefined) {
        delete data.addressTab
      }
      if(data.addressIdIndex !== undefined) {
        delete data.addressIdIndex
      }
      if(data.addressTab2 !== undefined) {
        delete data.addressTab2
      }
      this.$router.push({name: 'Ticketing', query: { data: JSON.stringify(data) }})
    },

    onSearchButtonClick (): void {
      this.ticketingList = []

      let data: any = this.getRouteData()

      data.nummer = this.nummer

      this.$router.push({name: 'Ticketing', query: { data: JSON.stringify(data) }})

      this.searchTickets()
    },

    onSelectionChanged (data: any) {
      this.isDetailButtonDisabled = data.selectedRowKeys.length <= 0

      let routeData: any = this.getRouteData()
      routeData.selectedRowKeys = data.selectedRowKeys
      this.$router.push({name: 'Ticketing', query: { data: JSON.stringify(routeData) }})
    },

    rowDblClick(event: any): void {
      this.ticketingIdList.push(event.data.id)
      this.showDialog = true

      let routeData: any = this.getRouteData()
      routeData.selectedRowKeys = [event.data.id]
      routeData.showDialog = this.showDialog
      this.$router.push({name: 'Ticketing', query: { data: JSON.stringify(routeData) }})
    },

    onDetailClick (): void {
      //@ts-ignore
      const selectedTicketingIdList: number[] = this.$refs.dataGrid.instance.getSelectedRowKeys()

      if(selectedTicketingIdList.length > 0) {
        this.ticketingIdList = selectedTicketingIdList
        this.showDialog = true

        let routeData: any = this.getRouteData()
        routeData.showDialog = this.showDialog
        this.$router.push({name: 'Ticketing', query: { data: JSON.stringify(routeData) }})
      }
    },

    onResize (): void {
      if(this.$refs.filter && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.filter as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 105px - ${height}px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    },

    async searchTickets (): Promise<void> {
      this.ticketingList = [
        { id: 1, eingereich: '09.01.2025', verantwortlich: 'Cronauer', nummer: 'CR023456', adresse: 'Syz AG Informatik', bezeichnung: 'Kalender Art Editing', planungsDatum: '20.01.2025', status: 'Assigned', prioritat: 'Normal' },
        { id: 2, eingereich: '10.02.2025', verantwortlich: 'Cronauer', nummer: 'CR023456', adresse: 'Syz AG Informatik', bezeichnung: 'Kalender Art Editing', planungsDatum: '28.02.2025', status: 'Assigned', prioritat: 'Normal' },
        { id: 3, eingereich: '12.02.2025', verantwortlich: 'Cronauer', nummer: 'CR023456', adresse: 'Syz AG Informatik', bezeichnung: 'Kalender Art Editing', planungsDatum: '28.02.2025', status: 'Assigned', prioritat: 'Normal' },
        { id: 4, eingereich: '18.02.2025', verantwortlich: 'Cronauer', nummer: 'CR023456', adresse: 'Syz AG Informatik', bezeichnung: 'Kalender Art Editing', planungsDatum: '19.02.2025', status: 'Assigned', prioritat: 'Normal' },
        { id: 5, eingereich: '15.03.2025', verantwortlich: 'Cronauer', nummer: 'CR023456', adresse: 'Syz AG Informatik', bezeichnung: 'Kalender Art Editing', planungsDatum: '18.03.2025', status: 'Assigned', prioritat: 'Normal' },
        { id: 6, eingereich: '01.04.2025', verantwortlich: 'Cronauer', nummer: 'CR023456', adresse: 'Syz AG Informatik', bezeichnung: 'Kalender Art Editing', planungsDatum: '10.04.2025', status: 'Assigned', prioritat: 'Normal' },
      ]

      let data: any = this.getRouteData()
      if(this.$route.path === '/ticketing' && data.selectedRowKeys) {
        let selectedRowKeyList: number[] = []
        this.ticketingList.forEach((item: any) => {
          if(data.selectedRowKeys.includes(item.id)) {
            selectedRowKeyList.push(item.id)
          }
        })

        setTimeout(() => {
          //@ts-ignore
          this.$refs.dataGrid.instance.selectRows(selectedRowKeyList)
          this.showDialog = data.showDialog !== undefined && selectedRowKeyList.length > 0 ? data.showDialog : false
        }, 100)
      }
    },

    updateRoute (id: number): void {
      this.ticketingIdList = [id]
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    },

    setDataFromRoute () {
      let data: any = this.getRouteData()

      if(this.$route.path === '/ticketing') {
        this.nummer = data && data.nummer ? data.nummer : ''


        this.ticketingIdList = data.selectedRowKeys ? data.selectedRowKeys : []

        if(!_.isEmpty(data)) {
          this.searchTickets()
        }
      }
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  beforeMount () {
    this.keyActions = [
      new SelectAll(KeyActionEnum.selectAll, this.selectAll, this.resolver,  null)
    ]
  },

  async mounted (): Promise<void> {
    window.addEventListener('keydown', this.onKeydown)

    this.setDataFromRoute()
    if(this.$route.query.create) {
      this.ticketingIdList = [0]
      this.showDialog = true
    }

    if(this.ticketingGroupId) {
      this.ticketingArt = this.ticketingGroupId
    }

    this.ticketingArtList = await this.$store.dispatch(FETCH_TICKETING_ART)

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
